import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=0b46db2c&"
import script from "./SearchPage.vue?vue&type=script&lang=ts&"
export * from "./SearchPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b46db2c')) {
      api.createRecord('0b46db2c', component.options)
    } else {
      api.reload('0b46db2c', component.options)
    }
    module.hot.accept("./SearchPage.vue?vue&type=template&id=0b46db2c&", function () {
      api.rerender('0b46db2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/search/SearchPage.vue"
export default component.exports